import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import { AuthProvider } from "./auth";
import Routes, { RoutesMenu, RouterWrapper } from "./routes";
import CoreLayout from "./layout";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import "antd/dist/antd.css";
import "./styles/utilities.css";

const queryClient = new QueryClient();

class App extends React.Component {
	componentDidMount() {
		// const accessToken = sessionStorage.getItem("LOS.access_token");
		// if(accessToken) {
		//     this.props.dispatchAction("AUTH.POSTED", null, { accessToken, status: "AUTHENTICATED" })
		// }
	}

	logout = () => {
		// this.props.dispatchAction(AUTH_ACTIONS.AUTH.RESET, null);
	};

	render() {
		return (
			<QueryClientProvider client={queryClient}>
				<Provider store={store}>
					<RouterWrapper>
						{Routes(CoreLayout, {
							user: this.props.user,
							logout: this.logout,
							menu: <RoutesMenu />,
						})}
					</RouterWrapper>
				</Provider>
				<ReactQueryDevtools initialIsOpen={false} />
			</QueryClientProvider>
		);
	}
}

// const mapDispatchToProps = dispatch => bindActionCreators({
//     // dispatchAction
// }, dispatch);

// const mapStateToProps = state => ({});

export default App;
